/*
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2024-04-18 10:47:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-26 14:19:39
 * @FilePath: \operation-center\src\views\websiteAdmin\antireptileSet\components\frequencySet\business\frequencySet.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { parseTime } from '@/utils/util'

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center',
  },
  {
    title: '使用平台',
    dataIndex: 'project',
    align: 'left',
    width: 260,
    scopedSlots: { customRender: 'project' },
  },
  {
    title: '设定时长（单位：s）',
    dataIndex: 'set_duration',
    width: 160,
    align: 'left',
  },
  {
    title: '请求次数（单位：次）',
    dataIndex: 'request_number',
    width: 160,
    align: 'left',
  },
  {
    title: '弹框类型',
    dataIndex: 'popup_type',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'popup_type' },
  },
  {
    title: '相关人员',
    dataIndex: 'user_id',
    align: 'left',
    width: 150,
    scopedSlots: { customRender: 'user_id' },
  },
  {
    title: '相关时间',
    dataIndex: 'created_at',
    align: 'left',
    width: 180,
    scopedSlots: { customRender: 'create_at' },
  },
  {
    title: '状态',
    dataIndex: 'state',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'state' },
  },
  {
    title: '操作',
    align: 'center',
    width: 120,
    // fixed: 'right',
    dataIndex: 'operator',
    scopedSlots: { customRender: 'operator' },
  },
]

export const searchForm = {
  line_id: undefined,
  popup_type: '',
  created_at: [],
  updated_at: [],
  created_name: '',
  updated_name: '',
  state: undefined,
}
